import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import styles from './Tag.module.scss'

interface Props {
  icon?: IconDefinition
  text: string
}

export const Tag = ({ icon, text }: Props) => {
  return (
    <span
      className={
        icon ? styles.container : `${styles.container} ${styles.default}`
      }
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      <span>{text}</span>
    </span>
  )
}
